import { Component, OnInit, Inject } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { API } from '../../../../services/Api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EditRole } from '../store/capabilities.actions';
import { GetRoles } from '../../user-management/store/user-managment.actions';


@Component({
    selector: 'app-edit-role',
    templateUrl: './edit-role.component.html',
    styleUrls: ['./edit-role.component.scss']
})
export class EditRoleComponent implements OnInit {
    editRoleForm: FormGroup;
    roleName: string;
    description: string;
    category: string;
    selectedCategory: string;
    roleKey: string;
    categories: Array<string> = []
    roleDetails: any;

    constructor(
        private store: Store<AppState>,
        private api: API,
        private router: Router,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.roleDetails = JSON.parse(this.activatedRoute.snapshot.params['roleDetails']);

        this.editRoleForm = this.fb.group({
            roleName: [this.roleDetails.roleName, Validators.required],
            description: [this.roleDetails.description || ""],
            category: [this.roleDetails.category, Validators.required]
        });

        this.store.dispatch(new GetRoles());
        this.store.select(state => state.userManagment.roles).pipe().subscribe(response => {
        if (response.status) {
                const categories = response.roles.map(role => role.category);
                this.categories = Array.from(new Set(categories));

                this.selectedCategory = this.roleDetails.category;
            }
        });
    }

    editRole() {
        this.roleKey = this.roleDetails.role;
        this.store.dispatch(new EditRole(this.roleKey, this.editRoleForm.value));
        this.store.select(state=> state.capabilities.editRoleResponse).pipe().subscribe(response => {
            this.goBack();
        });
    }

    goBack() {
        this.router.navigate(['home', 'role-management', 'list-capabilities']);
    }

}
